export default __webpack_public_path__ + "static/floor3-slide-4-564d6fcb5c9ef02061560249ae04637e.jpg";